import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { nowIso } from "../utils/timestamps";

export const createTripCargo = ({
  id = createUuid(),
  tripId,
  productName,
  quantity,
  unit,
  showTolerance = false,
  tolerances = [],
  billOfLadingReference,
  cargoLotId,
  createdAt = nowIso(),
  createdBy,
  updatedAt = createdAt,
  updatedBy,
  revision = 1,
  schemaVersion = SCHEMA_VERSIONS.TRIP_CARGO,
}) => {
  assertString(id, "tripCargo.id");
  assertString(tripId, "tripCargo.tripId");
  assertString(productName, "tripCargo.productName");
  assertString(unit, "tripCargo.unit");
  assertString(createdBy, "tripCargo.createdBy");
  assertString(updatedBy || createdBy, "tripCargo.updatedBy");

  return {
    id,
    tripId,
    productName,
    quantity,
    unit,
    showTolerance,
    tolerances,
    billOfLadingReference,
    cargoLotId,
    createdAt,
    createdBy,
    updatedAt,
    updatedBy: updatedBy || createdBy,
    revision,
    schemaVersion,
  };
};
